'use client';

import { useRouter } from 'next/navigation';
import { type Dispatch, type SetStateAction } from 'react';

import { trackAnalyticsEvent } from '@/app/lib/analytics';
import { Modal, ModalButton, BaseModalContent } from '@/components/modal';
import { ANALYTICS_EVENTS } from '@/constants';

type ExitConfirmationModalProps = {
  isModalOpen: boolean;
  setIsModalOpen: Dispatch<SetStateAction<boolean>>;
  url: string;
};

export const ExitConfirmationModal = ({
  isModalOpen = false,
  setIsModalOpen,
  url,
}: ExitConfirmationModalProps) => {
  const router = useRouter();

  function closeModal() {
    setIsModalOpen(false);
  }

  function openModal() {
    setIsModalOpen(true);
  }

  return (
    <Modal
      heading="Before we continue"
      description="You’re about to navigate away from the sign up form. By doing this your details will not be saved."
      isModalOpen={isModalOpen}
      closeModal={() => {
        trackAnalyticsEvent(
          ANALYTICS_EVENTS.signup.exitConfirmation.closeModal
        );
        closeModal();
      }}
      openModal={openModal}
      mobileSize="sm"
    >
      <BaseModalContent
        buttonComponent={
          <>
            <ModalButton
              variant="primary"
              onClick={() => {
                trackAnalyticsEvent(
                  ANALYTICS_EVENTS.signup.exitConfirmation.stayOnPage
                );
                closeModal();
              }}
            >
              Stay on page
            </ModalButton>
            <ModalButton
              variant="tertiary"
              onClick={() => {
                trackAnalyticsEvent(
                  ANALYTICS_EVENTS.signup.exitConfirmation.leaveForm
                );
                sessionStorage.removeItem('startSignUp');
                router.push(url);
                window.scrollTo({ top: 0, behavior: 'smooth' });
                closeModal();
              }}
            >
              Leave form
            </ModalButton>
          </>
        }
      />
    </Modal>
  );
};
